import React, { useContext, useEffect, useState } from "react";
import Modal from "../Modal/Modal";
import "./CardPackage.css";
import Card from "react-bootstrap/Card";
import { CardContent, Checkbox } from "@material-ui/core";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Server } from "../../../../constants";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DataContext } from "../../../pages/ConfiguraHyundai";

const CardPackage = React.memo((props) => {
    const [listaKitsOrigen, setListaKitsOrigen] = useState([]); // Lista que llega desde el servicio
    const [listaKits, setListaKits] = useState([]); // Lista que se muestra en TAB kits
    const [listaAccesoriosOrigen, setListAccesoriosOrigen] = useState([]);
    const [listaAccesorios, setListAccesorios] = useState([]);
    const {
        accesoriosIndividuales,
        setAccesoriosIndividuales,
        kits,
        setKits,
        modeloSeleccionado
    } = useContext(DataContext);

    useEffect(() => {
        const obtenerPaquetes = async () => {
            const url = `${Server}/api/configura/kit-modelo/${modeloSeleccionado?.MOD_CODIGO}/${modeloSeleccionado?.versionSeleccionada.VER_CODIGO}`
            await axios
                .get(url)
                .then((response) => {
                    let respuestaListaKitsOrigen = response.data.data;
                    setListaKitsOrigen(respuestaListaKitsOrigen);
                    if (kits?.length === 0) {
                        setListaKits(respuestaListaKitsOrigen);
                    } else {
                        validarKitDuplicado(kits, respuestaListaKitsOrigen);
                    }
                })
                .catch(function (error) {
                    return [];
                })
        }
        const obtenerAccesorios = async () => {
            const url = `${Server}/api/configura/item-modelo/${modeloSeleccionado?.MOD_CODIGO}/${modeloSeleccionado?.versionSeleccionada.VER_CODIGO}`
            await axios
                .get(url)
                .then((response) => {
                    let respuestaListaAccesorios = response.data.data;
                    setListAccesoriosOrigen(respuestaListaAccesorios)

                    if (kits?.length === 0) {
                        setListAccesorios(respuestaListaAccesorios)
                    } else {
                        validarAccesoriosDuplicados(kits, respuestaListaAccesorios)
                    }
                })
                .catch(function (error) {
                    return [];
                })
        }
        if (listaKitsOrigen.length === 0) {
            obtenerPaquetes();
        }
        if (listaAccesoriosOrigen.length === 0) {
            obtenerAccesorios();
        }
    }, [kits, listaAccesoriosOrigen.length, listaKitsOrigen.length, modeloSeleccionado])

    const seleccionarKit = (item, event) => {
        var esSuma = event.target.checked;
        var listaKitsActual = [];
        if (esSuma) {
            props.calcularPrecioItem("SUMAR", item.CK_PVP);
            listaKitsActual = [...kits, item]
        } else {
            props.calcularPrecioItem("RESTAR", item.CK_PVP);
            listaKitsActual = kits.filter((elemento) => elemento.CK_ID !== item.CK_ID);
        }
        setKits(listaKitsActual)
        validarKitDuplicado(listaKitsActual, listaKitsOrigen);
        validarAccesoriosDuplicados(listaKitsActual, listaAccesoriosOrigen);
        eliminarAccesoriosDeKitsSeleccionados(item);
    }

    const validarKitDuplicado = (listaKits, listaKitsOrigen) => {
        // Recorro la lista origen en busqueda de kits que no se repitan
        var nuevaLista = listaKitsOrigen.filter((kitOrigen) => {
            var _listaAccesorios = kitOrigen.LISTA_ACCESORIOS
            //Obtener lista de ID de accesorios del Kit Actual.
            var _listaCodigosAccesorios = _listaAccesorios.map(
                (_accesorio) => {
                    return _accesorio.CA_ID
                }
            )
            //Obtener Lista de ID de Todos los Accesorios Seleccionados
            var _listaAccesoriosSeleccionados = []
            listaKits.forEach((_kit) => {
                // Si el ID del Kit Origen es igual al ID del KIT de la lista de KIT
                // retornar el elemento.
                if (_kit.CK_ID === kitOrigen.CK_ID) {
                    return kitOrigen;
                }
                // Caso contrario agrego el cada accesorio de la lista a una nueva Lista
                _kit.LISTA_ACCESORIOS.forEach((accesorio) => {
                    _listaAccesoriosSeleccionados.push(accesorio);
                })
            })
            // De la lista de codigos, obtengo solo los ID
            var _listaCodigosAccesoriosSelecionados = _listaAccesoriosSeleccionados.map(
                (_accesorio) => {
                    return _accesorio.CA_ID
                }
            )
            // Comparo cada ID de la LISTA SELECCIONADA con cada ID de los accesorios del KIT ACTUAL (Filter Padre)
            var esDuplicado = false;
            _listaCodigosAccesoriosSelecionados.forEach((codigoAccesorio) => {
                if (_listaCodigosAccesorios.includes(codigoAccesorio)) {
                    esDuplicado = true;
                    return;
                }
                ;
            });
            return !esDuplicado && kitOrigen;
        });
        setListaKits(nuevaLista);
    }

    const validarAccesoriosDuplicados = (listaKitActual, listaAccesoriosOrigen) => {
        var codigosAccesorios = []
        listaKitActual.forEach((kit) => {
            kit.LISTA_ACCESORIOS.forEach((accesorio) => {
                codigosAccesorios.push(accesorio.CA_ID)
            })
        })
        var listaAccesoriosActualizada = listaAccesoriosOrigen.filter((accesorio) => {
            return !codigosAccesorios.includes(accesorio.CA_ID) && accesorio;
        })
        setListAccesorios(listaAccesoriosActualizada);
    }

    const eliminarAccesoriosDeKitsSeleccionados = async (kit) => {
        let nuevaListaAccesoriosSeleccionados = accesoriosIndividuales.filter(
            (_accesorioIndividual) => {
                let existeItemEnKit = kit.LISTA_ACCESORIOS.some((_accesorio) => {
                    return _accesorio.CA_ID === _accesorioIndividual.CA_ID
                })
                if (existeItemEnKit) {
                    toast(`Se retiro el item: ${_accesorioIndividual.CA_NOMBRE_ACC}, porque ya existe en el paquete, ${kit.CK_NOMBRE_KIT}`,)
                }
                return !existeItemEnKit && _accesorioIndividual;
            }
        )
        setAccesoriosIndividuales(nuevaListaAccesoriosSeleccionados);
    }

    const seleccionarIndividuales = (item, event) => {
        var esSuma = event.target.checked;
        if (esSuma) {
            props.calcularPrecioItem("SUMAR", item.CA_PVP);
            setAccesoriosIndividuales([...accesoriosIndividuales, item])
        } else {
            props.calcularPrecioItem("RESTAR", item.CA_PVP);
            var nuevaLista = accesoriosIndividuales.filter(
                elemento => elemento.CA_ID !== item.CA_ID
            )
            setAccesoriosIndividuales(nuevaLista)
        }
    }

    const kitEstaSeleccionado = (pack) => {
        var estaSeleccionado = false;
        kits.forEach((kit) => {
            if (kit.CK_ID === pack.CK_ID) estaSeleccionado = true;
        })
        return estaSeleccionado;
    }

    const accesorioEstaSeleccionado = (item) => {
        var estaSeleccionado = false;
        accesoriosIndividuales.forEach((accesorio) => {
            if (accesorio.CA_ID === item.CA_ID) estaSeleccionado = true;
        })
        return estaSeleccionado;
    }

    return (
        <section>
            <ToastContainer
                style={{ width: "800px", fontSize: '12px', fontFamily: 'HyundaiSansHead-Light' }}
                position="bottom-center"
                autoClose={9000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {
                props.optionSelected === 'kit' &&
                listaKits.map((pack) => {
                    return <div key={pack.CK_ID}>
                        <Card className='sombra'>
                            <CardContent>
                                <Row>
                                    <Col xs={2}>
                                        <Checkbox
                                            value={pack.CK_ID}
                                            color="primary"
                                            onChange={(event) => seleccionarKit(pack, event)}
                                            className="check-box-acc"
                                            checked={kitEstaSeleccionado(pack)}
                                        />
                                    </Col>
                                    <Col xs={10}>
                                        <span>{pack.CK_NOMBRE_KIT}</span> <br />
                                        <span>Precio: {pack.CK_PVP.toLocaleString('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        })}</span>
                                        <Modal
                                            tabSelected={props.optionSelected}
                                            listaKits={pack.LISTA_ACCESORIOS}
                                            estaSeleccionado={kitEstaSeleccionado(pack)}
                                        >
                                        </Modal>
                                    </Col>
                                </Row>
                            </CardContent>
                        </Card>
                    </div>
                })
            }
            {
                props.optionSelected === 'individual' &&
                listaAccesorios?.map((item) => {
                    return <div key={item.CA_ID}>
                        <Card className='sombra'>
                            <CardContent>
                                <Row>
                                    <Col xs={2}>
                                        <Checkbox
                                            value={item.CA_ID}
                                            color="primary"
                                            onChange={(event) => seleccionarIndividuales(item, event)}
                                            className="check-box-acc"
                                            checked={accesorioEstaSeleccionado(item)}
                                        />
                                    </Col>
                                    <Col xs={10}>
                                        <span>{item.CA_NOMBRE_ACC}</span> <br />
                                        <span>Precio:{(item.CA_PVP).toLocaleString('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        })}</span>
                                        <Modal tabSelected={props.optionSelected}
                                            accesorio={item}
                                        ></Modal>
                                    </Col>
                                </Row>
                            </CardContent>
                        </Card>
                    </div>
                })
            }
        </section>
    );
});
export default CardPackage;